// extracted by mini-css-extract-plugin
module.exports = {"contentBlockWrapper":"base_contentBlockWrapper__ntIB7","basicButton":"base_basicButton__593tw","fadein":"base_fadein__Gwkp_","loading":"base_loading__tbHMp"};